<!-- Expanded -->
<div
  class="h-full w-[380px] border-0 border-r border-solid border-gray-200"
  [class.hidden]="collapsed()"
  [formGroup]="form"
>
  <!-- Search Bar + Toggle sidebar button -->
  <div
    class="flex flex-shrink-0 items-center gap-2 border-b border-gray-100 p-3"
  >
    <ri-resolution-ui-search-bar
      class="flex-grow"
      placeholder="Search tasks..."
      formControlName="searchString"
      [delay]="1000"
      (searchStringChange)="onSearchStringChange($event)"
    ></ri-resolution-ui-search-bar>
    <button matButton
      (click)="toggleSidebar()"
    >
      <i class="r1-icon r1-icon-chevron-left-light"></i>
    </button>
  </div>

  <!-- Open and My Recently Completed tabs -->
  <div [class.hidden]="activeSearch()">
    <mat-tab-group
      [selectedIndex]="activeTabIndex()"
      (selectedTabChange)="onActiveTabChange($event)"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      animationDuration="0ms"
    >

      <mat-tab label="Open">

        <div class="mt-6 px-3">
          <!-- My Tasks or Unassigned -->
          <ri-resolution-ui-my-open-tasks
            #myOpenTasksRef
          ></ri-resolution-ui-my-open-tasks>
        </div>
      </mat-tab>

      <mat-tab label="My Recently Completed">
        <div class="mt-6 px-3">
          <!-- My completed tasks -->
          <ri-resolution-ui-completed-tasks
            #completedTasksRef
          ></ri-resolution-ui-completed-tasks>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>

  <!-- Search results list -->
  <div [class.hidden]="!activeSearch()">
    <ri-resolution-ui-search-result-tasks
      #searchResultTasksRef
    ></ri-resolution-ui-search-result-tasks>
  </div>
</div>

<!-- Collapsed -->
@if (collapsed()) {
  <div
    class="h-full w-16 flex-shrink-0 border-0 border-r border-solid border-gray-200 pt-4 text-center"
  >
    <button matButton (click)="toggleSidebar()">
      <i class="r1-icon r1-icon-chevron-right-light"></i>
    </button>
  </div>
}
